import { css } from 'lit';

export const IxGenericTreeNodeStyles = css`
  :root,
  :host :root,
  :host {
    --md-circular-progress-size: 14px;
    --md-circular-progress-active-indicator-width: 10;
    --md-filled-text-field-top-space: 8px;
    --md-filled-text-field-bottom-space: 8px;
    --md-filled-text-field-container-color: #f5f7ff;
    --md-filled-text-field-container-shape-end-end: 4px;
    --md-filled-text-field-container-shape-end-start: 4px;
    --md-filled-text-field-focus-active-indicator-height: 0px;
    --md-filled-text-field-hover-active-indicator-height: 0px;
    --md-filled-text-field-active-indicator-height: 0px;
  }

  *,
  :before,
  :after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  md-checkbox {
    --md-checkbox-outline-color: var(
      --ix-generic-tree-node-outline-colour,
      rgb(91, 107, 124)
    );
  }

  md-checkbox[indeterminate] {
    --md-checkbox-selected-container-color: var(
      --ix-generic-tree-indeterminate-node-background-color,
      #53657a
    );
    --md-checkbox-selected-hover-container-color: var(
      --ix-generic-tree-indeterminate-node-background-color,
      #53657a
    );
  }

  .inherited {
    display: flex;
    cursor: default;
    background: var(--ix-generic-tree-inherited-node-background-color, #53657a);
    height: var(--ix-generic-tree-inherited-node-height, 18px);
    width: var(--ix-generic-tree-inherited-node-width, 18px);
    border-radius: var(--ix-generic-tree-inherited-node-border-radius, 2px);
    color: var(--ix-generic-tree-inherited-node-icon-color, #ffffff);
    line-height: var(--ix-generic-tree-inherited-node-icon-line-height, 1);
    --ix-icon-font-size: var(--ix-tree-inherited-node-icon-font-size, 18px);
  }

  ix-icon-button {
    --md-sys-color-on-surface-variant: #6b7a8d;
  }

  md-filled-text-field {
    width: 100%;
  }

  .secondary-label {
    color: #6b7a8d;
    text-align: left;
  }

  .child-count {
    margin: 0px;
    color: var(--cp-neutral-blue-60p, #09224199);
  }

  .label {
    letter-spacing: 0.25px;
  }

  .node-item {
    width: -moz-max-content;
    width: max-content;
    display: flex;
    align-items: center;
    user-select: none;
  }

  .node-item.selected {
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    --tw-bg-opacity: 1;
    background-color: rgb(241 245 249 / var(--tw-bg-opacity, 1));
  }

  .node-item-icon {
    padding-right: 0.75rem;
  }

  .node-item-label {
    padding: 0rem;
    cursor: pointer;
  }

  .node-item-selected {
    background-color: #fccf00;
  }

  .node-item-searched {
    background-color: #feec99;
  }

  .node-item-inner {
    display: flex;
    align-items: center;
  }

  @keyframes pulse {
    50% {
      opacity: 0.5;
    }
  }

  .animate-pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .dlr-text-caption {
    font-family: var(--root-primary-font);
    font-size: var(--text-caption-size);
    line-height: var(--text-caption-line-height);
    letter-spacing: var(--text-caption-letter-spacing);
    font-weight: var(--text-caption-weight);
    text-decoration: var(--text-caption-decoration);
    text-transform: var(--text-caption-transform);
  }

  .dlr-text-small {
    font-family: var(--root-primary-font);
    font-size: var(--text-small-size);
    line-height: var(--text-small-line-height);
    letter-spacing: var(--text-small-letter-spacing);
    font-weight: var(--text-small-weight);
    text-decoration: var(--text-small-decoration);
    text-transform: var(--text-small-transform);
  }

  .pl-2 {
    padding-left: 0.5rem;
  }

  .pl-4 {
    padding-left: 1rem;
  }

  .mt-2 {
    margin-top: 0.5rem;
  }

  ix-textbox {
    display: block;
    margin-bottom: 1rem;
  }
`;
